import { Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { LoginComponent } from './auth/login/login.component';
import { ResetpasswordComponent } from './auth/resetpassword/resetpassword.component';
import { DashboardComponent } from './master/dashboard/dashboard.component';
import { MainComponent } from './master/main/main.component';

export const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'resetpass', component: ResetpasswordComponent },
  {
    path: 'master', component: MainComponent,
    children: [
      { path: '', component: DashboardComponent },
      {
        path: 'cards',
        loadChildren: () => import('./cards/cards.module').then(m => m.CardsModule)
      },
      {
        path: 'options',
        loadChildren: () => import('./options/options.module').then(m => m.OptionsModule)
      },
      {
        path: 'reports',
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
      },
      {
        path: 'systemsettings',
        loadChildren: () => import('./systemsettings/systemsettings.module').then(m => m.SystemsettingsModule)
      },
      {
        path: 'efawateercome',
        loadChildren: () => import('./e-fawateercom/e-fawateercom.module').then(m => m.EFawateercomModule)
      },
      {
        path: 'efawateercomereports',
        loadChildren: () => import('./e-fawateercom-reports/e-fawateercom-reports.module').then(m => m.EFawateercomReportsModule)
      }

    ], canActivate: [AuthGuard]
  },
  // { path: '**', redirectTo: '' }
];

// @NgModule({
//   imports: [RouterModule.forRoot(routes)],
//   exports: [RouterModule]
// })
// export class AppRoutingModule { }
